export function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
  var tick = Math.min(duration, 10),
    unit = (to.indexOf('%') >= 0) ? '%' : 'px',
    to = to.replace(unit, ''),
    from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')),
    positionTick = (to - from) / duration * tick,
    running;

  setTimeout(moveElement, tick);
  function moveElement() {
    duration -= tick;
    from += positionTick;
    element.style[attr] = prefix + from + unit + postfix;
    if (duration > 0) {
      setTimeout(moveElement, tick);
    } else {
      callback();
    }
  }
}
